<template>
  <b-modal
    v-model="showModal"
    centered
    header-class="custom-modal-header"
    footer-class="custom-modal-footer"
  >
    <template #modal-header>
      <p class="text-header">
        {{ form.id == 0 ? "CREATE" : "UPDATE" }} RESOLUTION TIME
      </p>
    </template>
    <b-row>
      <b-col>
        <InputText
          v-model="form.name"
          name="form.name"
          textFloat="Name"
          placeholder="Name"
          type="text"
          isRequired
          :isValidate="$v.form.name.$error"
          :v="$v.form.name"
        />
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <InputText
          v-model="form.from"
          textFloat="From"
          placeholder="From"
          type="text"
          isRequired
          :isValidate="$v.form.from.$error"
          :v="$v.form.from"
          @onKeyup="convertName('from')"
        />
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <InputText
          v-model="form.to"
          textFloat="To"
          placeholder="To"
          type="text"
          isRequired
          :isValidate="$v.form.to.$error"
          :v="$v.form.to"
          @onKeyup="convertName('to')"
        />
      </b-col>
    </b-row>
    <template #modal-footer>
      <div class="w-100 d-flex justify-content-between">
        <button :disabled="isLoading" class="cancel-button" @click="hide()">
          Cancel
        </button>
        <button :disabled="isLoading" class="save-button" @click="onSubmit()">
          Save
        </button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import InputText from "@/components/inputs/InputText";
import {
  required,
  decimal,
  minValue,
  maxValue,
} from "vuelidate/lib/validators";

export default {
  name: "ModalCreateOrEdit",
  components: {
    InputText,
  },
  props: {
    typeId: {
      type: Number,
    },
  },
  validations() {
    return {
      form: {
        name: { required },
        from: {
          required,
          decimal,
          maxValue: maxValue(
            this.form.to == 0 ? this.form.from + 1 : this.form.to
          ),
        },
        to: {
          required,
          decimal,
          minValue: minValue(this.form.to == 0 ? 0 : this.form.from),
        },
      },
    };
  },
  data: function () {
    return {
      showModal: false,
      form: {
        id: 0,
        name: "",
        from: "",
        to: "",
        typeId: this.typeId,
      },
      isLoading: false,
    };
  },
  methods: {
    show(item) {
      this.$v.$reset();
      if (item === null) {
        this.form = {
          id: 0,
          name: "",
          from: "",
          to: "",
          typeId: this.typeId,
        };
      } else this.form = { ...item };
      this.showModal = true;
    },
    hide() {
      this.showModal = false;
    },
    async onSubmit() {
      this.$v.$touch();
      if (this.$v.form.$error) return;

      this.isLoading = true;

      await this.axios
        .post(`${this.$baseUrl}/analytics/timegroup`, this.form)
        .then((data) => {
          if (data.result == 1) {
            this.$store.commit("UPDATE_GLOBAL_ALERT", {
              isShow: true,
              msg: data.message,
            });
            this.$emit("reloadData");
          } else
            this.$store.commit("UPDATE_GLOBAL_ALERT_ERROR", {
              isShow: true,
              msg: data.message,
            });
        })
        .catch((err) => {
          this.$store.commit("UPDATE_GLOBAL_ALERT_ERROR", {
            isShow: true,
            msg: err.message,
          });
        });
      this.isLoading = false;
    },
    minToDays(min, ep, type) {
      let days = Math.floor((min * ep) / 1440);
      let remainingTime = parseInt(min * ep - Math.floor(days * 1440));
      let hours = Math.floor(remainingTime / 60);
      let remainingMin = Math.floor(remainingTime - hours * 60);
      let result = "";
      if (days) result += ` ${days} d`;
      if (hours) result += ` ${hours} hr`;
      if (remainingMin) result += ` ${remainingMin} min`;
      return result.trim();
    },
    convertName(type) {
      let name = "";
      if (this.form.from < 1) {
        name += `0`;
      }else {
        name += this.minToDays(this.form.from, 1, type);
      }
      if (this.form.to > 0) {
        name += ` to `;
        name += this.minToDays(this.form.to, 1, type);
      } else {
        name = `-> ${name}`;
      }
      name += `.`;

      this.form.name = name;
    },
  },
};
</script>
